import './Error.sass';

export default function Error({ error }) {
	return <div className='page-error'>{error}</div>;
}
